export default "__VITE_ASSET__341dd63e__"